export enum SupportedHrefTypes {
  self = '_self',
  blank = '_blank',
}
